import React, { ReactNode } from "react";

import { customIcon } from "./custom-icon";

const singleFrameElements = () => (
  <g transform="translate(-50.25 -10.25)">
    <line className="cls-1" y2="16" transform="translate(51 11)" />
    <line className="cls-1" y2="16" transform="translate(74 11)" />
    <g transform="translate(1 3)">
      <line className="cls-2" y2="17" transform="translate(70 12) rotate(90)" />
      <line className="cls-2" x1="17" transform="translate(53 14)" />
      <line className="cls-2" x1="17" transform="translate(53 16)" />
      <line className="cls-2" x1="17" transform="translate(53 18)" />
      <line className="cls-2" x1="17" transform="translate(53 20)" />
    </g>
  </g>
);

const singleFrameDefs = (): ReactNode[] => [
  <style key="0">
    {`
      .cls-1, .cls-2 {
        fill: none;
        stroke: #cdcdcd;
        stroke-width: 1.5px;
      }

      .cls-1 {
        stroke-linecap: round;
      }
    `}
  </style>,
];

export const singleFrameIcon = customIcon({
  path: singleFrameElements(),
  defs: singleFrameDefs(),
  viewboxDefault: [24.5, 17.5],
});
